import styled from 'styled-components';
import { PrimaryButton } from '@fluentui/react';

export const StyledPrimaryButton = styled(PrimaryButton)`
  padding: 24px 16px;
  border-radius: 3px;
`;
